export default __webpack_public_path__ + "static/media/node-.4968692c.svg";